import * as React from 'react';
import { observable } from "mobx";
import { observer } from "mobx-react";
import autobind from "autobind-decorator";
import { Modal, Radio, Button } from 'antd';

const RadioGroup = Radio.Group;

/**
 * IChoiceGroupOption
*/
interface IChoiceGroupOption {
    key: string;
    text: string;
	checked?: boolean;
	disabled?: boolean;
}
/**
 * OptionsDialogViewProps
*/
interface OptionsDialogViewProps {
    showDialog: boolean;
    closeDialog: (selectedValue?: string) => void;
    options: IChoiceGroupOption[];
    title: string;
    subtitle: string;
}
/**
 * OptionsDialogView class
 */
@observer
export class OptionsDialogView extends React.Component<OptionsDialogViewProps, any> {
	// Selected Value
    @observable
    selectedValue: string;
	/**
	 * Constructor
	 * @param props
	 */
    constructor(props) {
        super(props);
    }
	/**
	 * Component did mount
	 */
    componentDidMount() {
        const selectedOption = this.props.options.find(e => e.checked);
        if (selectedOption) {
            this.selectedValue = selectedOption.key;
        }
    }
	/**
	 * Render
	 */
    render() {
		// Load Radio buttons Values
        let radioValues = [];
        if (this.props.options != null) {
			// Show vertical Radio buttons
            const radioStyle = {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            };

			this.props.options.forEach((opt) => {
				radioValues.push(<Radio key={opt.key} style={radioStyle} disabled={opt.disabled} value={opt.key}>{opt.text}</Radio>);
            });
        }

        return (
            <Modal
                title={this.props.title}
                wrapClassName="vertical-center-modal"
                visible={this.props.showDialog}
                maskClosable={false}
                onOk={this.acceptOption}
                onCancel={this.closeDialog}
                footer={[
                    <Button key="Ok" type="primary" onClick={this.acceptOption}>Ok</Button>,
                    <Button key="Cancel" onClick={this.closeDialog}>Cancel</Button>,
                ]}
            >
                <p>{this.props.subtitle}</p>
                <RadioGroup onChange={this.onChange} value={this.selectedValue} size='large'>
                    {radioValues}
                </RadioGroup>
            </Modal >);
    }

    @autobind
    private closeDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
        ev.preventDefault();
        this.props.closeDialog();
    }

    @autobind
    private acceptOption(ev?: React.MouseEvent<HTMLButtonElement>) {
        ev.preventDefault();
        this.props.closeDialog(this.selectedValue);
    }

    @autobind
    private onChange(ev?: any) {
        this.selectedValue = ev.target.value;
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/options-dialog.view.tsx